import styled from 'styled-components';

const BusinessCardStyle = styled.div`
	&.businessCardCont {
		--afterElementSize: var(--sp1-5x);

		position: relative;
		width: 100vw;
		left: 50%;
		transform: translate3d(-50%, 0, 0);

		.businessCard {
			position: relative;
			width: 100%;

			.cardCont {
				position: relative;
				padding: var(--sp3x);
				background-color: var(--color1);
				border: 2px solid var(--color2);
				z-index: 2;
			}

			.mailWrap {
				display: flex;
				flex-wrap: wrap;
				justify-content: flex-end;
				margin-bottom: var(--sp8x);

				.mail {
					@media (hover: hover) {
						&:hover {
							text-decoration: underline;
						}
					}
				}
			}

			.numberAndLocationWrap {
				display: flex;
				flex-wrap: wrap;

				.numberAndLocationItem {
					margin-right: var(--sp7x);
					margin-bottom: var(--sp5x);
					max-width: var(--sp26x);

					&:last-child {
						margin-bottom: 0;
					}

					a {
						display: block;

						@media (pointer: fine) {
							@media (hover: hover) {
								&:hover {
									text-decoration: underline;
								}
							}
						}
					}

					.b-city {
						margin-bottom: var(--sp0-5x);
					}

					.phone {
						margin-top: var(--sp2x);
						letter-spacing: -1.5px;
					}
				}
			}
		}

		.backBg {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background-color: var(--color2);
			z-index: -1;
			border: 1px solid var(--color1);
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			.businessCard {
				--bgSize: var(--sp1-5x);

				max-width: 100%;
				width: auto;
				margin: 0 calc(var(--containerPaddingLR) + var(--bgSize)) 0 var(--containerPaddingLR);

				.backBg {
					top: var(--bgSize);
					left: var(--bgSize);
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) and (min-width: 0) {
			.mailWrap a {
				font-size: var(--h6);
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			.businessCard {
				.numberAndLocationWrap {
					.numberAndLocationItem {
						margin-bottom: 0;
					}
				}

				.mailWrap a {
					font-size: var(--h5);
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			--afterElementSize: var(--sp3x);

			.businessCard {
				max-width: 76%;

				.mailWrap {
					margin-bottom: var(--sp11x);
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			display: flex;
			align-items: center;
			justify-content: center;
			padding-bottom: var(--afterElementSize);

			.businessCard {
				.cardCont {
					padding: var(--sp3x);
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
			min-height: 100vh;

			.businessCard {
				position: absolute;
				top: 0;
				left: 0;

				.cardCont {
					padding: var(--sp4x);
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
			--afterElementSize: var(--sp2x);

			.businessCard {
				max-width: 75%;

				.mailWrap {
					margin-bottom: var(--sp15x);
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
			--afterElementSize: var(--sp3x);

			.businessCard {
				.mailWrap {
					margin-bottom: var(--sp18x);
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
			.businessCard {
				max-width: 60%;

				.numberAndLocationWrap {
					.numberAndLocationItem {
						max-width: var(--sp29x);
						margin-right: var(--sp9x);
					}
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
			--afterElementSize: var(--sp3x);

			.businessCard {
				.cardCont {
					padding: var(--sp5x);
				}

				.mailWrap {
					margin-bottom: var(--sp22x);
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
			--afterElementSize: var(--sp4x);

			.businessCard {
				max-width: 63%;

				.mailWrap {
					margin-bottom: var(--sp24x);
				}

				.numberAndLocationWrap {
					.numberAndLocationItem {
						margin-right: var(--sp12x);
					}
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
			--afterElementSize: var(--sp4x);

			.businessCard {
				max-width: var(--sp128x);

				.cardCont {
					padding: var(--sp6x);
				}

				.mailWrap {
					margin-bottom: var(--sp25x);
				}

				.numberAndLocationWrap {
					.numberAndLocationItem {
						margin-right: var(--sp12x);
						max-width: var(--sp34x);
					}
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
			--afterElementSize: var(--sp5x);

			.businessCard {
				max-width: var(--sp152x);

				.cardCont {
					padding: var(--sp8x);
				}

				.mailWrap {
					margin-bottom: var(--sp32x);
				}

				.numberAndLocationWrap {
					.numberAndLocationItem {
						margin-right: var(--sp14x);
						max-width: var(--sp38x);
					}
				}
			}
		}
	}
`;

export default BusinessCardStyle;
